import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

const body = document.querySelector("body");

/*------------------------------------------------
ハンバーガーメニュー
--------------------------------------------------*/
  let button = document.querySelector('.hd_menu_btn');
  let nav_box = document.querySelector('.hd_nav_box');

  if (button && nav_box) {
    button.addEventListener('click', function() {

      if (nav_box.classList.contains('is_open')) {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      } else {
        nav_box.classList.add("is_open");
        button.classList.add("is_close");
      }

    });
  }

/*------------------------------------------------
ハンバーガーメニュー　リンク押したらメニュー閉じる
--------------------------------------------------*/
  let links = document.querySelectorAll('.header-nav__link');
  links.forEach((link) => {
    link.addEventListener('click', function() {
      setTimeout(() => {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      }, 100);
    });
  });

/*----------------------------------------
カーソル設定
------------------------------------------*/
const cursor = document.getElementById('custom-cursor');
const cursorTargets = document.querySelectorAll('a, button');

// 768px以上のメディアクエリを設定
const mediaQuery = window.matchMedia('(min-width: 768px)');

// マウス移動時の処理
const handleMouseMove = (e) => {
  cursor.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
};

// リンクにホバーした時の処理
const handleMouseEnter = () => {
  cursor.classList.add('is-hovered');
  cursorTargets.forEach(l => l.classList.add('is-hovered'));
};

// リンクから離れた時の処理
const handleMouseLeave = () => {
  cursor.classList.remove('is-hovered');
  cursorTargets.forEach(l => l.classList.remove('is-hovered'));
};

// イベントリスナーの登録・解除を切り替える関数
function setupCursor(e) {
  if (e.matches) {
    // 768px以上の場合：イベントを追加、カーソルを表示
    if (cursor) cursor.style.display = 'block';

    document.addEventListener('mousemove', handleMouseMove);
    cursorTargets.forEach(link => {
      link.addEventListener('mouseenter', handleMouseEnter);
      link.addEventListener('mouseleave', handleMouseLeave);
    });
  } else {
    // 768px未満の場合：イベントを削除、カーソルを非表示
    if (cursor) cursor.style.display = 'none';

    document.removeEventListener('mousemove', handleMouseMove);
    cursorTargets.forEach(link => {
      link.removeEventListener('mouseenter', handleMouseEnter);
      link.removeEventListener('mouseleave', handleMouseLeave);
    });

    // クラスが残ってしまっていたときのためにクリアしておく
    cursor?.classList.remove('is-hovered');
    cursorTargets.forEach(l => l.classList.remove('is-hovered'));
  }
}

// 初回実行
setupCursor(mediaQuery);

// 画面サイズが変更されたときにも監視
mediaQuery.addEventListener('change', setupCursor);

/*----------------------------------------
indexページ 実績紹介スワイパー設定
------------------------------------------*/
window.addEventListener('load', () => {
  if (document.body.classList.contains("home")) {
    // 4.6vw を px に変換する関数
    const getVwPx = () => window.innerWidth * 0.046;
    const swiperElement = document.querySelector('.index-performance_swiper');
    if (!swiperElement) return;

    const swiper = new Swiper('.index-performance_swiper', {
      loop: true, // ループを有効にする
      centeredSlides: true, // スライドを中央に配置する
      slidesPerView: 1.5,
      speed: 9000, // ループ中の移動速度
      autoplay: {
        delay: 0, // 途切れなく流し続ける
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },

      allowTouchMove: false, // タッチ操作を無効にする
      handleTouchStart: false, // タッチ開始時の処理を無効にする
      simulateTouch: false, // マウス操作を無効にする
      observer: true, // SwiperのDOM変更を監視する
      observeParents: true, // 親要素のDOM変更も監視する

      // sp時
      spaceBetween: 16,

      breakpoints: {
        481: {
          slidesPerView: 2.5,
          spaceBetween: 16,
        },
        769: {
          slidesPerView: 3.5,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: getVwPx(),
        }
      },
      on: {
        init: function () { adjustZigzag(this); },
        slideChange: function () { adjustZigzag(this); },
        loopFix: function() { adjustZigzag(this); }
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1024) {
        swiper.params.slidesPerView = 3.5;
        swiper.params.spaceBetween = getVwPx();
      } else if (window.innerWidth >= 769) {
        swiper.params.slidesPerView = 3.5;
        swiper.params.spaceBetween = 16;
      } else if (window.innerWidth >= 481) {

        swiper.params.slidesPerView = 2.5;
        swiper.params.spaceBetween = 16;
      } else {

        swiper.params.slidesPerView = 1.5;
        swiper.params.spaceBetween = 16;
      }
      swiper.update();

      if (swiper.autoplay && !swiper.autoplay.running) {
        swiper.autoplay.start();
      }
    });
  }
});

// ジグザグクラスを制御する関数
function adjustZigzag(swiper) {
  setTimeout(() => {
    if (!swiper.slides || swiper.slides.length === 0) return;

    swiper.slides.forEach((slide) => {
      const originIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
      if (!isNaN(originIndex)) {
        if (originIndex % 2 === 0) {
          slide.classList.add('is_lower');
        } else {
          slide.classList.remove('is_lower');
        }
      }
    });
  }, 50);
}

/*------------------------------------------------
採用情報ページ 数字アニメーション&タイトルアニメーション
--------------------------------------------------*/
if (document.body.classList.contains("recruit")) {
  document.addEventListener("DOMContentLoaded", () => {
    const letters = "0123456789";

    const startNumberAnimation = (element) => {
      const text = element.textContent;
      element.textContent = "";

      text.split("").forEach((char) => {
        const span = document.createElement("span");
        span.textContent = char === " " ? " " : "0";
        element.appendChild(span);
      });

      element.classList.add("is-active");

      const spans = element.querySelectorAll("span");
      spans.forEach((span, index) => {
        if (span.textContent !== " ") {
          let iterations = 0;
          const interval = setInterval(() => {
            span.textContent = letters[Math.floor(Math.random() * letters.length)];
            iterations++;
            if (iterations > 10 + index * 2) {
              clearInterval(interval);
              span.textContent = text[index];
            }
          }, 40);
        }
      });
    };

    // 共通の監視設定
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const target = entry.target;

          // クラス名によって処理を振り分ける
          if (target.classList.contains("recruit-data_num")) {
            startNumberAnimation(target);
          } else if (target.classList.contains("recruit-top_title")) {
            target.classList.add("is-animated");
          }

          // 動いたら監視を解除
          observer.unobserve(target);
        }
      });
    }, { rootMargin: "0px 0px -15% 0px" });

    // 両方の要素を一斉に監視登録
    document.querySelectorAll(".recruit-data_num, .recruit-top_title").forEach((el) => {
      observer.observe(el);
    });
  });
}

/*----------------------------------------
お問い合わせ アニメーション
------------------------------------------*/
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
function getHeaderHeight() {
  const header = document.querySelector('.header');
  return header ? header.offsetHeight : 0;
}

document.addEventListener('tccf7:scrollTo', e => {

  const targetElement = document.getElementById(e.detail.id);

  if (targetElement) {
    gsap.to(window, {
      duration: 1,
      scrollTo: {
        offsetY: getHeaderHeight()
      },
      ease: "power2.inOut"
    });
  }
});


/*----------------------------------------
お問い合わせバリデーション
------------------------------------------*/
if(document.body.classList.contains("contact")){
  topValidation('zip', 'address01', 'address02');
}

/*----------------------------------------
smooth scroll page内リンク
------------------------------------------*/
gsap.registerPlugin(ScrollToPlugin);
window.addEventListener("load", () => {
  const navLinks = document.querySelectorAll('a[href^="#"]');

  navLinks.forEach((navLink) => {
    navLink.addEventListener("click", (e) => {
      e.preventDefault();
      const id = navLink.getAttribute("href");
      const currentOffset = window.innerWidth <= 1024 ? 60 : 165;

      window.dispatchEvent(new CustomEvent('gsapScrollStart'));

      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: id,
          offsetY: currentOffset
        },
        onComplete: () => {
          window.dispatchEvent(new CustomEvent('gsapScrollEnd'));
        }
      });
    });
  });
});

/*----------------------------------------
smooth scroll page外リンク
------------------------------------------*/
window.addEventListener('load', () => {
  if (location.hash) {
    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    const urlHash = location.hash;

    setTimeout(() => {
      gsap.set(window, {
        scrollTo: {
          y: urlHash,
          offsetY: headerHeight
        }
      });
    }, 0);
  }
});

/*------------------------------------------------
テーブル横スクロール
--------------------------------------------------*/
let scrollArea = document.getElementsByClassName("active_scroll");//クラス取得

  if(scrollArea) {// 取得した要素すべてに処理
    for(let i = 0; i < scrollArea.length; i++) {
      let newElement = document.createElement("p");//<p>を新しく追加
      newElement.classList.add("scroll_ico");//クラスを追加
      newElement.textContent = 'スクロールできます';//テキストを追加
      scrollArea[i].appendChild(newElement);

      scrollArea[i].addEventListener("touchstart", () => {//ユーザーがタッチしたら非表示
        let scrollIconEle = scrollArea[i].lastElementChild;
        scrollIconEle.style.display = "none";
      });
    }
  }

/*------------------------------------------------
要素アニメーション
--------------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  const mvTitleElements = [
    document.querySelector(".mv_title_01"),
    document.querySelector(".mv_title_02"),
    document.querySelector(".mv_title_03")
  ].filter(Boolean);

  // 画面内のすべての対象要素（複数）を一括で取得
  const animeElements = document.querySelectorAll(".anime-target:not(.mv_title_01):not(.mv_title_02):not(.mv_title_03)");
  if (!animeElements.length && !mvTitleElements.length) return; // 要素がなければ処理をスキップ

  const observerOptions = {
    root: null,
    rootMargin: "0px 0px -30% 0px", // 画面の下側から10%入ったら発火
    threshold: 0
  };

  if (animeElements.length) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        // それぞれの要素が「自分の画面内」に入ったかを個別に判定
        if (entry.isIntersecting) {
          // 画面に入ったその要素だけに「.anime」を付与
          entry.target.classList.add("anime");

          // その要素のアニメーションは完了したので、個別に監視を解除
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // ループ処理で、すべての要素（複数）を1つずつ監視カメラに登録
    animeElements.forEach((element) => {
      observer.observe(element);
    });
  }

  if (mvTitleElements.length) {
    const mvTitleObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        mvTitleElements.forEach((element, index) => {
          setTimeout(() => {
            element.classList.add("anime");
          }, index * 700);
        });

        observer.unobserve(entry.target);
      });
    }, {
      root: null,
      rootMargin: "0px 0px -15% 0px",
      threshold: 0
    });

    mvTitleObserver.observe(mvTitleElements[0]);
  }
});

/*------------------------------------------------
indexページ 事業カード レールグライドアニメーション
--------------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  if (!document.body.classList.contains("home")) return;

  const businessList = document.querySelector(".index-business_list");
  if (!businessList) return;

  const businessCards = businessList.querySelectorAll(".index-business_card");
  if (!businessCards.length) return;

  const isLgViewport = window.matchMedia("(max-width: 1024px)").matches;

  businessCards.forEach((card) => {
    card.classList.add("is-index-business-pop-ready");
  });

  const businessObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (isLgViewport) {
        entry.target.classList.toggle("is-index-business-bubble-in", entry.isIntersecting);
        return;
      }

      if (!entry.isIntersecting) return;

      if (!isLgViewport) {
        entry.target.classList.add("is-index-business-pop-in");
      } else {
        entry.target.classList.add("is-index-business-bubble-in");
      }

      observer.unobserve(entry.target);
    });
  }, {
    root: null,
    rootMargin: isLgViewport ? "0px 0px 5px 0px" : "0px 0px -10% 0px",
    threshold: isLgViewport ? 0.1 : 0.2
  });

  businessCards.forEach((card) => {
    businessObserver.observe(card);
  });
});